import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const File = forwardRef<SVGSVGElement, SvgIconProps>(function File(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path
        d="M13,5.26829268 L13,17.5210643 C13,17.7848621 12.8006307,18 12.5561878,18 L0.443812233,18 C0.199360455,18 0,17.7848525 0,17.5210643 L0,0.478935698 C0,0.215137916 0.199369331,0 0.443812233,0 L8.11806543,0 L8.11806543,3.83148559 C8.11806543,4.62192106 8.71703442,5.26829268 9.44950213,5.26829268 L13,5.26829268 Z M9.44950213,4.31042129 L12.378441,4.31042129 L9.0056899,0.670749446 L9.0056899,3.83148559 C9.0056899,4.09528337 9.20505923,4.31042129 9.44950213,4.31042129 Z"
        transform="translate(6, 3)"
      />
    </SvgIcon>
  )
})

export default File
